var map = {
	"./Data/DUT/layout.json": 5914,
	"./Data/EN/layout.json": 9208,
	"./Data/EST/layout.json": 9081,
	"./Data/FR/layout.json": 9130,
	"./Data/LIT/layout.json": 4808,
	"./Data/LTV/layout.json": 8497,
	"./Data/NRW/layout.json": 5843,
	"./Data/POR/layout.json": 1142,
	"./Data/SWD/layout.json": 9800
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2253;